export default "SELECT database_id, schema_id, owner_id, name\n  FROM sys.schema\n  WHERE database_id = $(database_id)\n    AND NAME NOT IN ('pg_catalog')\n"